import { useEffect, useState } from 'react';
import { inspectionDB } from '../data/database.structure';
import { EquipmentConfigurationModel } from '../data/types';

const useGETFitments = () => {
  const [fitments, setFitments] = useState<EquipmentConfigurationModel[]>([]);

  useEffect(() => {
    const getGETFitments = async () => {
      try {
        const fitments = await inspectionDB.equipmentConfigurations.toArray();

        setFitments(fitments.filter((f) => f.id > 0));
      } catch (error) {
        console.error(error);
      }
    };

    getGETFitments();
  }, []);

  return fitments;
};

export default useGETFitments;
